<div class="d-flex flex-row justify-content-center">
  <a [routerLink]="PathNews | page: [slug] | localize" class="box-shadow p-2" [title]="title" appEmptyTitle>
    <div class="d-flex flex-column box-news-in-evidence">
      <span class="box-news-date mb-2">{{date | myDate: 'L'}}</span>
      <picture>
        <img [alt]="title" class="box-news-img object-fit-cover" [src]="img">
      </picture>
      <p class="text-uppercase elsa-title-font box-news-title ellipsized-text four-lines-text my-2">{{title}}</p>
      <div class="w-100 ellipsized-description two-lines-text">
        {{description}}
      </div>
    </div>
  </a>
</div>
